export default {
  notVeBatch: {
    service: '您尚未开通视频批量制作服务，请联系销售进行授权。',
  },
  validateMessage: '仅支持数字、字母、下划线',
  form: {
    setting: {
      min: '最小值',
      max: '最大值',
    },
  },
  back: '返回',
  projectName: '项目名称',
  editProject: {
    label: '重命名',
    form: {
      name: {
        placeholder: '请输入项目名称',
        empty: '项目名称不能为空',
      },
    },
  },
  editVersion: {
    label: '重命名',
    form: {
      name: {
        placeholder: '请输入版本名称',
        empty: '版本名称不能为空',
      },
    },
  },
  copyLink: '复制链接',
  copied: '已复制',
  listEmpty: '暂无数据',
  creativeInfo: {
    form: {
      direction: {
        tips: '项目创建后，不支持修改适配方向。建议复制项目后重新选择并编辑。',
      },
    },
  },
  common: {
    model: {
      cocos: {
        rule: {
          size: '文件大小超过1M',
          filenum: 'zip文件数量不匹配',
          name: '文件名称或者后缀大小写不一致',
        },
      },
    },
    button: {
      close: '关闭',
    },
    form: {
      inputTips: '请输入',
      checkTips: '请勾选',
    },
  },
  productSelector: {
    selectTips: '选择推广产品',
    select: '选择',
    handler: '从库里选择',
  },
  create: {
    name: '新建',
    successful: '新建成功',
  },
  hint: '提示',
  fold: '收起',
  more: '查看更多',
  templatel: {
    delete: {
      noadd: '是否确认删除模板',
    },
  },
  noresults: '无结果',
  download: '下载',
  push: '推送',
  noData: '暂无数据',
  choice: '请选择',
  search: {
    noresult: '抱歉，没有找到符合条件的结果，建议更换不同的搜索条件。',
    text: '搜索',
  },
  trial: {
    application: '申请试用',
  },
  notsubscribed: {
    service: '您尚未开通该服务，请联系销售进行授权。',
  },
  cancel: '取消',
  submit: '提交',
  startupload: '开始上传',
  startdownload: '开始下载',
  confirm: '确认',
  OK: '确定',
  apply: '申请',
  gotit: '知道了',
  operate: {
    successful: '操作成功',
  },
  delete: {
    successful: '删除成功',
  },
  update: {
    successful: '更新成功',
  },
  add: {
    uccessful: '添加成功',
  },
  storagefull: {
    tips: '存储空间已满，无法进行操作。请清理资产库数据或联系销售进行空间扩容。',
  },
  copy: {
    successful: '复制成功',
  },
  reset: '重置',
  custom: '自定义',
  plPoint: {
    dialog: '-',
    list: {
      title: '埋点日志',
    },
    point: {
      gs: '可玩展示',
      fc: '首次交互',
      ge: '试玩结束',
      is: '跳转',
      scene: '场景{num}展示',
    },
    pointType: {
      base: '基础埋点',
      custom: '自定义埋点',
    },
  },
}
